// extracted by mini-css-extract-plugin
module.exports = {"view-slider-item-wrapper-info-title":"styles__view-slider-item-wrapper-info-title__qKBNI","viewSliderItemWrapperInfoTitle":"styles__view-slider-item-wrapper-info-title__qKBNI"};